<template>
	<main class="deal-request">
		<TokenRequest requestType="Deal" @token-request-submit="checkRequestType" />
		<SpvOptions
			:show="showSpvOptions"
			v-if="showSpvOptions"
			:id="id"
			@close-spv-options="showSpvOptions = false"
		/>
	</main>
</template>

<script>
import SpvOptions from "@/components/privateRaise/spv/SpvOptions";
import TokenRequest from "@/components/privateRaise/TokenRequest";
import { mapActions, mapGetters } from "vuex";
export default {
	name: "DealRequest",
	components: { TokenRequest, SpvOptions },
	data() {
		return {
			showSpvOptions: false,
		};
	},
	computed: {
		...mapGetters("TokenModule", ["token"]),
		id() {
			return this.token?._id;
		},
	},
	methods: {
		...mapActions(["showToast"]),
		...mapActions("TokenModule", [
			"requestToken",
			"updateTokenRequest",
			"getTokenRequest",
		]),
		checkRequestType(token) {
			if (this.token) {
				this.editTokenRequest(token);
			} else {
				this.placeTokenRequest(token);
			}
		},
		async placeTokenRequest(token) {
			try {
				await this.requestToken(token);
				// this.showSpvOptions = true;
				this.$router.push({
					name: "PrivateRaise",
				});
			} catch (error) {
				return error;
			}
		},
		async editTokenRequest(payload) {
			try {
				const id = this.id;
				delete payload.asset_id;
				delete payload.total_raised;
				const response = await this.updateTokenRequest({ payload, id });
				const { message } = response.data;
				this.showToast({
					description: message,
					display: true,
					type: "success",
				});
				await this.fetchTokenRequest();
			} catch (error) {
				return error;
			}
		},
		async fetchTokenRequest() {
			try {
				await this.getTokenRequest(this.$route.params.id);
			} catch (error) {
				return error;
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.deal-request {
	font-family: 'DM Sans', -apple-system, BlinkMacSystemFont, sans-serif;
}
</style>
